// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3WvfH","imageUploader":"EGiftCard_imageUploader___7NHQ"};